import React, { useContext, useEffect, useState } from 'react'
import Button from '../components/button'
import Top from '../components/top'
import Table from '../components/table'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'
import { DetailsContext } from '../contexts/DetailsContext'

const Cost = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {
      user,
      setUser,
      isLogged,
      setIsLogged,
      login,
      logout
    } = useContext(AuthContext)

    const { costs } = useContext(DetailsContext)
    
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])

    const inputs = [
        {
          name: "service",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Service Name',
        },
        {
          name: "amount",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Cost Amount'
        },
        {
            name: "initiator",
            icon: 'fa-solid fa-user',
            type: 'text',
            placeholder: 'Enter Initiator Username'
          }
      ]

    props.setNavShow(true)
    function formatNumber(number) {
      return number.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
      });
  }
    const userColumns = ['Cost ID', 'Service', 'Amount', 'Date', 'Initiator']
    function addUsers(){
        window.location.replace('/edit')
    }
    const link = 'https://xgramm.com/xgramm_backend/admin/cost.php'
  return (
    <div  style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={true} value='Add New Cost' name='Costs'/>
        <div className="w3-container">
        <Table tableName='cost' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='Cost' columns={userColumns} data={costs ? costs : []} summary={false} edit={true} />
        </div>
    </div>
  )
}

export default Cost